import React from "react";
import ShowPaginationData from "../../components/UI/TableView/ShowPaginationData";
import dayjs from "dayjs";
import { t } from "i18next";

export default function RequestedCourse() {
  const { columns, id, label, url, href } = {
    id: 'courses', label: 'courses',
    href: '/courses',
    columns: [{ label: '#', value: a => a._id },
    { label: 'name', sort: 'userName', classnames: () => 'font-[Montserrat]', value: (a) => a.userName },
    { label: 'captainName', sort: 'trainer.name', classnames: () => 'font-[Montserrat]', value: (a) => a.trainer[0]?.name },
    { label: 'courseType', sort: 'courseType', classnames: () => 'font-[Montserrat]', value: (a) => a.courseType===0?t('online'):t('paper') },
    { label: 'price', sort: 'price', value: (a) => a.price + ' - ' + a.iqd },
    { label: 'date', sort: 'createdAt', value: (a) => dayjs(a.createdAt).format('YYYY-MM-DD HH:mm') },
    ],
    url: (centerId) => `/courses?startDate=${dayjs().format('YYYY-MM-DD')}&endDate=${dayjs().format('YYYY-MM-DD')}&` + centerId,
  }

  return (
    <div className="flex flex-col items-center w-full bg-white">
      <ShowPaginationData defaultSort={[{ sort: 'createdAt', sortBy: 1 }]} hrefId={null} onClickItem={(data) => {}}  rightButton={<div className="cursor-pointer" >
      </div>} columns={columns} href={href} id={id} label={label} url={url} />
    </div>
  );
}
